import React, { useContext, useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AppContext } from "../../../../context/AppContext";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { latestDate } from "../../../../sharedComponent/common";
import CommonDatePicker from "../../../../sharedComponent/CommonDatePicker";
import Import from "../../../../assets/images/ic-Import.svg";
import ApiConfig from "../../../../api/ApiConfig";
import { simplePostCall } from "../../../../api/ApiServices";
import Loader from "../../../../sharedComponent/Loader";
import NoDataComp from "../../../../sharedComponent/NoDataComp";
import { Select } from "antd";

const { Option } = Select;

const DevicesWithoutVehicleDetails = () => {
  const { sidebar } = useContext(AppContext);
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [deviceType, setDeviceType] = useState("");
  const [searchText, setSearchText] = useState("");
  const [currentDate, setCurrentDate] = useState({ toDayDate: new Date() });
  const [OptionDownload, setOptionDownload] = useState("");
  const [OrderListData, setOrderListData] = useState([]);
  const maxDate = new Date();

  const aninations = {
    initial: { opacity: 0, x: 400 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
  };

  useEffect(() => {
    fetchReport();
  }, [deviceType, currentDate, OptionDownload]);

  /* === GREEN :: API INTEGRATED === */
  const fetchReport = () => {
    const body = {
      format: OptionDownload,
      vehicle_id: "",
      date: latestDate(currentDate.toDayDate, "yyyy-MM-dd"),
    };
    setLoading(true);
    setOptionDownload("");
    simplePostCall(
      ApiConfig.DEVICES_WITHOUT_VEHICLE_DETAILS,
      JSON.stringify(body)
    )
      .then((res) => {
        if (res?.result) setOrderListData(res?.listData || []);
        else setOrderListData([]);
      })
      .catch((err) => console.log("Error:", err))
      .finally(() => setLoading(false));
  };

  return (
    <motion.div
      className={sidebar ? "taskMain " : "cx-active taskMain"}
      id="cx-main"
      variants={aninations}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.1 }}
    >
      <div id="cx-wrapper" className="Vehicle_inspition_dashboard heightFixed">
        <div className="report-viwe-head" id="Viwe_Report_Respoasive">
          <p></p>
        </div>

        <div className="col-lg-12 mt-0">
          <div className="UserTabel">
            <div className="heading">
              <div>
                <p>
                  <p>{t("Devices Without Vehicle Details")}</p>
                </p>
              </div>

              <div className="multi-select-1">
                <Select
                  style={{ height: "40px", width: "180px" }}
                  className="custom-select"
                  placeholder={t("Device Type")}
                  value={deviceType}
                  onChange={(value) => setDeviceType(value)}
                >
                  <Option value="" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("All Devices")}
                  </Option>
                  <Option value="gps" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("GPS")}
                  </Option>
                  <Option value="rfid" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("RFID")}
                  </Option>
                  <Option value="camera" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Camera")}
                  </Option>
                  <Option value="obd" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("OBD")}
                  </Option>
                </Select>
              </div>

              <div className="innerSelectBox">
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("Search IMEI / Serial...")}
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  style={{ height: "40px", width: "220px" }}
                />
              </div>

              {/* === GREEN :: API INTEGRATED (date filter) === */}
              <div className="innerSelectBox weekCounter datepicker-main">
                <CommonDatePicker
                  dateKey={"toDayDate"}
                  setDate={setCurrentDate}
                  data={currentDate}
                  SetPlaceholder={t("Today Date")}
                  dataDisbal={maxDate}
                />
              </div>

              <div className="right-export-btn-section-wrapper">
                <div className="md_dropdown">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      <img src={Import} alt="" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item>
                        <Link onClick={() => setOptionDownload("pdf")} className="d-block">
                          {t("PDF")}
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link onClick={() => setOptionDownload("excel")} className="d-block">
                          {t("Excel")}
                        </Link>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>

            {/* === GREEN :: API INTEGRATED (table fields mapped to API response) === */}
            <table className="table tableAdmin">
              <thead className="tableHead">
                <tr className="text-center">
                  <th>{t("Sr No")}</th>
                  <th>{t("User Name")}</th>
                  <th>{t("Vehicle Number")}</th>
                  <th>{t("IMEI No")}</th>
                  <th>{t("Latitude")}</th>
                  <th>{t("Longitude")}</th>
                  <th>{t("Activity Status")}</th>
                  <th>{t("Speed")}</th>
                  <th>{t("Logged Date")}</th>
                  <th>{t("Logged Time")}</th>
                </tr>
              </thead>
              {loading ? (
                <Loader />
              ) : (
                <tbody className="tableBody">
                  {OrderListData && OrderListData?.length > 0
                    ? OrderListData.map((item, index) => (
                        <tr className="text-center" key={index}>
                          <td>{index + 1}</td>
                          <td>{item.user_name}</td>
                          <td>{item.vehicle_number}</td>
                          <td>{item.vehicle_imei}</td>
                          <td>
                            {item.latitude} {item.latitude_direction}
                          </td>
                          <td>
                            {item.longitude} {item.longitude_direction}
                          </td>
                          <td>{item.vehicle_activity_status}</td>
                          <td>{item.speed}</td>
                          <td>
                            {item.logged_date
                              ? latestDate(item.logged_date, "yyyy-MM-dd")
                              : ""}
                          </td>
                          <td>{item.logged_time}</td>
                        </tr>
                      ))
                    : null}
                </tbody>
              )}
            </table>

            {OrderListData?.length === 0 && !loading && <NoDataComp />}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default DevicesWithoutVehicleDetails;
